import { translateNavigationPathToAnalytics } from 'analytics/analyticsUtils';
import { reportNavigation } from 'analytics/reporters';
import { leftFromBackButton, resetLeaveFromBackButton } from 'ducks/sheets';
import { getVpcCode } from 'ducks/vpc';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import usePrevious from './usePrevious';
import { useAppDispatch } from 'ducks/hooks';

export const useNavigationEvents = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const vpcCode = useSelector(getVpcCode);
  const userLeftFromBackButton = useSelector(leftFromBackButton);
  const previousLocation = usePrevious(location);
  const performance = window.performance.getEntriesByType('navigation')[0];

  useEffect(() => {
    const to = translateNavigationPathToAnalytics(location.pathname);
    const from = translateNavigationPathToAnalytics(previousLocation?.pathname ?? '');
    if (to !== from && to && from) {
      const event = {
        to,
        from,
        designCode: vpcCode ? vpcCode : undefined,
        userLeftFromBackButton,
        pageLoadTime: performance?.duration ?? 0
      };

      reportNavigation(event);
    }

    /* It seems this does not reset properly, but with this we make sure the navigation after a back-button navigation resets it*/
    if (userLeftFromBackButton) {
      dispatch(resetLeaveFromBackButton());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};
